/* eslint-disable max-classes-per-file */
import type { ExperienceCardItemClassInterface } from "@/libs/server/goApiServer/experience/ExperienceServiceInterface/ResponseExperienceCardInterface";
import { convertToBoolean } from "@/utils/common/formatHelper/booleanUtills";

import { CouponDetail } from "./getPromotionStaticInterface";

export interface RequestPromotionDetailInterface {
  id?: number;
  slug?: string;
}

export interface RequestPromotionLandingInterface {
  slug: string;
}

export interface SeoInterface {
  title: string;
  description: string;
}

export interface Deeplink {
  utmid: {
    44: {
      deeplink: string;
    };
    45: {
      deeplink: string;
    };
    46: {
      deeplink: string;
    };
  };
}

export class PromotionDetail {
  id: number;

  title: string;

  description: string;

  startPrice: number;

  currency: string;

  product: string;

  fullImage: string;

  thumbImage: string;

  mobileImage: string;

  startDate: string;

  expireDate: string;

  is_gother: string;

  status: string;

  slug: string;

  url: string;

  seo: SeoInterface;

  constructor(data: any) {
    this.id = data.id || 0;
    this.title = data.title || "";
    this.description = data.description || "";
    this.startPrice = data.startPrice || 0;
    this.currency = data.currency || "";
    this.product = data.product || "";
    this.fullImage = data.fullImage || "";
    this.thumbImage = data.thumbImage || "";
    this.mobileImage = data.mobileImage || "";
    this.startDate = data.startDate || "";
    this.expireDate = data.expireDate || "";
    this.is_gother = data.is_gother || "";
    this.status = data.status || "";
    this.slug = data.slug || "";
    this.url = data.url || "";
    this.seo = {
      title: data.seo.title || "",
      description: data.seo.description || "",
    };
  }
}
export class ResponsePromotionDetail {
  promotions: PromotionDetail[];

  destinationType: number;

  success: boolean;

  isRequireLogin: boolean;

  constructor(data: any) {
    this.destinationType = data.destination_type ?? 9;
    this.promotions = (data.promotions || []).map(
      (promotion: any) => new PromotionDetail(promotion),
    );

    this.success = data.success || false;

    this.isRequireLogin = convertToBoolean(data.isRequireLogin);
  }
}

export class FlightCardItemInterface {
  flightOfferId: string;

  airlineSlug: string;

  airlineName: string;

  flightType: string;

  ticketingPeriod: string;

  travelPeriod: string;

  fromAirportCode: string;

  toAirportCode: string;

  countrySlug: string;

  price: number;

  flightName: string;

  countryName: string;

  cityName: string;

  citySlug: string;

  photoPath: string;

  flightOfferSlug: string;

  airportCityTo: string;

  airportCityFrom: string;

  airlineLogo: string;

  currency: string;

  cityFromName: string;

  cityFromSlug: string;

  cityToName: string;

  cityToSlug: string;

  dateSearchDeparture: string;

  dateSearchReturn: string;

  ticketingPeriodEnd: string;

  ticketingPeriodStart: string;

  travelPeriodEnd: string;

  travelPeriodStart: string;

  isSpecialDeal: boolean;

  isRecommended: boolean;

  constructor(data: any) {
    this.flightOfferId = data.flightOfferId || "";
    this.airlineSlug = data.airlineSlug || "";
    this.airlineName = data.airlineName || "";
    this.flightType = data.flightType || "";
    this.dateSearchDeparture = data.dateSearchDeparture || "";
    this.dateSearchReturn = data.dateSearchReturn || null;
    this.ticketingPeriod = data.ticketingPeriod || "";
    this.travelPeriod = data.travelPeriod || "";
    this.fromAirportCode = data.fromAirportCode || "";
    this.toAirportCode = data.toAirportCode || "";
    this.price = data.price || 0;
    this.flightName = data.flightName || "";
    this.cityName = data.cityName || "";
    this.countryName = data.countryName || "";
    this.citySlug = data.citySlug || "";
    this.photoPath = data.photoPath || "";
    this.flightOfferSlug = data.flightOfferSlug || "";
    this.airportCityTo = data.airportCityTo || "";
    this.airportCityFrom = data.airportCityFrom || "";
    this.airlineLogo = data.airlineLogo || "";
    this.currency = data.currency || "";
    this.countrySlug = data.countrySlug || "";
    this.cityFromName = data.cityFromName || "";
    this.cityFromSlug = data.cityFromSlug || "";
    this.cityToName = data.cityToName || "";
    this.cityToSlug = data.cityToSlug || "";
    this.ticketingPeriodEnd = data.ticketingPeriodEnd || "";
    this.ticketingPeriodStart = data.ticketingPeriodStart || "";
    this.travelPeriodEnd = data.travelPeriodEnd || "";
    this.travelPeriodStart = data.travelPeriodStart || "";
    this.isSpecialDeal = data.isSpecialDeal || false;
    this.isRecommended = data.isRecommended || false;
  }
}

export class HotelCardItemInterface {
  id: number;

  images: string[];

  imageCover: string;

  title: string;

  hotelStar: number;

  location: string;

  latitude: number;

  longitude: number;

  isFavourite: boolean;

  isGreenCertificate?: boolean;

  countrySlug: string;

  countryName: string;

  citySlug: string;

  areaName: string;

  cityName: string;

  areaSlug: string;

  hotelSlug: string;

  hotelSlugPath: string;

  constructor(data: any) {
    this.id = data.id;
    this.images = data.images || [];
    this.imageCover = data.imageCover || "";
    this.title = data.title || "";
    this.hotelStar = data.hotelStar || 0;
    this.location = data.location || 0;
    this.latitude = data.latitude || 0;
    this.longitude = data.longitude || 0;
    this.isFavourite = data.isFavourite || false;
    this.countrySlug = data.countrySlug || "";
    this.countryName = data.countryName || "";
    this.isGreenCertificate = data.isGreenCertificate || false;
    this.cityName = data.cityName || "";
    this.citySlug = data.citySlug || "";
    this.areaSlug = data.areaSlug || "";
    this.hotelSlug = data.hotelSlug || "";
    this.areaName = data.areaName || "";
    this.hotelSlugPath = `${this.countrySlug}/${this.citySlug}/${this.areaSlug}/${this.hotelSlug}`;
  }
}

export class TravelPeriod {
  type: string;

  start: string;

  end: string;

  constructor(data: any) {
    this.type = data.type || "";
    this.start = data.start || "";
    this.end = data.end || "";
  }
}

export class CouponsDetail {
  title: string;

  conditionValue: string;

  couponId: string;

  couponItemId: number;

  description: string;

  subDescription: string;

  couponAmountType: string;

  couponAmount: string;

  currency: string;

  couponCode: string;

  createdAt: string;

  isOutOfStock: boolean;

  couponProductType: string[];

  travelPeriod: TravelPeriod;

  isRequireLogin: boolean;

  constructor(data: any) {
    const isOutOfStock = !data.isOutOfStock
      ? +data.id === 147296 || +data.id === 568
      : convertToBoolean(data.isOutOfStock);

    this.couponItemId = data.couponItemId || 0;
    this.description = data.description || "";
    this.subDescription = data.subDescription || "";
    this.couponAmountType = data.couponAmountType || "";
    this.couponAmount = data.couponAmount || "";
    this.currency = data.currency || "";
    this.couponCode = data.couponCode || "";
    this.couponId = data.couponId || "";
    this.title = data.title || "";
    this.conditionValue = data.conditionValue || "";
    this.couponProductType = data.couponProductType || [];
    this.isOutOfStock = data.isOutOfStock || isOutOfStock;
    this.createdAt = data.createdAt || "";
    this.travelPeriod = data.travelPeriod || {};
    this.isRequireLogin = data.isRequireLogin || false;
  }
}

export class PromotionLandingCoupon {
  coupon: CouponDetail[];

  coupons: CouponsDetail[];

  dataHotel: HotelCardItemInterface[];

  dataFlight: FlightCardItemInterface[];

  dataExperience: ExperienceCardItemClassInterface[];

  constructor(data: any) {
    this.coupon = (data.coupon || []).map(
      (item: any) => new CouponDetail(item),
    );
    this.coupons = (data.coupons || []).map(
      (item: any) => new CouponsDetail(item),
    );
    this.dataHotel = data.data_hotel || null;
    this.dataFlight = data.data_flight || null;
    this.dataExperience = data.data_experience || null;
  }
}

export class ResponsePromotionLanding {
  status: string;

  type: string;

  destinationType: number;

  promotionTitle: string;

  fullImage: string;

  thumbImage: string;

  mobileImage: string;

  homeImage: string;

  promotionStartDate: string;

  promotionEndDate: string;

  promotions: PromotionLandingCoupon;

  isRequireLogin: boolean;

  deeplink: Deeplink;

  constructor(data: any, slug?: string) {
    const promotionRequireLogin =
      process.env.NEXT_PUBLIC_PROMOTION_SLUG_REQUIRE_LOGIN;

    let isRequireLogin: boolean = false;
    if (data.isRequireLogin) {
      isRequireLogin = convertToBoolean(data.isRequireLogin);
    } else if (slug && promotionRequireLogin) {
      isRequireLogin = slug === promotionRequireLogin;
    }

    this.status = data.status || false;
    this.type = data.type || "";
    this.destinationType = data.destination_type ?? 9;
    this.promotionTitle = data.promotion_title || "";
    this.fullImage = data.fullImage || "";
    this.thumbImage = data.thumbImage || "";
    this.mobileImage = data.mobileImage || "";
    this.homeImage = data.homeImage || "";
    this.promotionStartDate = data.promotion_start_date || "";
    this.promotionEndDate = data.promotion_end_date || "";
    this.promotions = new PromotionLandingCoupon(data.promotions);
    this.isRequireLogin = isRequireLogin;
    this.deeplink = data.deeplink || {};
  }
}
